export const environment = {
  production: true,
  buildId: '2817895900619381',
  configFile: 'config.json',
};
